function getPerformanceStatistics(state) {
  return {
    statisticsError: state.performance.statisticsError,
    postingStatistics: state.performance.postingStatistics,
    priceStatistics: state.performance.priceStatistics,
    priceError: state.performance.priceError,
    priceLoading: state.performance.priceLoading,
    performanceStatus: state.performance.performanceStatus,
    bestPostingStatistics: state.performance.bestPostingStatistics,
    loadingPostingStatistics: state.performance.loadingPostingStatistics,
    loadingPerformance: state.performance.loadingPerformance,
    hasPerformanceData: state.performance.hasPerformanceData
  };
}

export { getPerformanceStatistics };
